import React, { useEffect, useRef, useState } from "react";
import {
  Typography,
  IconButton,
  TextField,
  Button,
  MenuItem,
  TablePagination,
  Dialog,
  DialogActions,
  DialogContent,
  Box,
  Checkbox,
  FormControlLabel,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import Grid from "@mui/material/Grid2";
import { ReactComponent as GridViewIcon } from "../../Assets/Gridview.svg";
import { ReactComponent as ListViewIcon } from "../../Assets/Listview.svg";
import { ReactComponent as CopiedIcon } from "./../../Assets/experience_copy.svg";
import { Search } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import {
  addExperienceList,
  copyExperience,
  ExperienceStatusChange,
  getExperienceList,
  getSchduleData,
} from "../../Services/ExperienceApi";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import { ReactComponent as AddIcon } from "../../Assets/add.svg";

import { ReactComponent as BriefcaseIcon } from "../../Assets/briefcase.svg";
import { ReactComponent as KeyIcon } from "../../Assets/key.svg";
import { ReactComponent as LiveIcon } from "../../Assets/live.svg";
import { ReactComponent as CircleIcon } from "../../Assets/circle.svg";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import { ReactComponent as EditedIcon } from "../../Assets/EditIcon.svg";
import { ReactComponent as ReportIcon } from "../../Assets/report.svg";
import { ReactComponent as StatusLiveIcon } from "../../Assets/StatusLive.svg";
import { ReactComponent as ScheduledIcon } from "../../Assets/scheduled.svg";
import { ReactComponent as OfflineIcon } from "../../Assets/offline.svg";

const validationSchema = Yup.object({
  name: Yup.string().required("Name is Required"),
  type: Yup.string()
    .test(
      "is-not-default",
      "Type is required",
      (value) => value !== "Select Type"
    )
    .required("Type is Required"),
});
const type = [
  { label: "Select Type", value: "Select Type" },
  { label: "Paywall", value: "paywall" },
  { label: "Lightbox", value: "lightbox" },
];
const Experience: React.FC = () => {
  const [search, setSearch] = useState("");
  const [sortOrder, setSortOrder] = useState(() => {
    return localStorage.getItem("sortOrder") || "all";
  });
  const [statusFilter, setStatusFilter] = useState(() => {
    return localStorage.getItem("statusFilter") || "all";
  });
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [openSchedulePopup, setOpenSchedulePopup] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10); // Items per page
  const [experiences, setExperiences] = useState([]);
  const [totalExperiences, setTotalExperiences] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [selected, setSelected] = useState<{ [key: string]: string }>({});
  const [selectedExpId, setSelectedExpId] = useState<string>();
  const [selectedExp, setSelectedExp] = useState<any>({});
  const [stopError, setStopError] = useState("");
  const [viewMode, setViewMode] = useState<any>("grid");
  const [selectedExpName, setSelectedExpName] = useState<any>({});
  const minDateTime = dayjs().format("YYYY-MM-DDTHH:mm");
  const now = new Date();
  const userDetails = JSON.parse(localStorage.getItem("userDetails") || "{}");
  const formattedNow = now.toISOString().slice(0, 16);
  const [copyLoadingId, setCopyLoadingId] = useState<string | null>(null);

  const [schedule, setSchedule] = useState<{
    start: string;
    stopEnabled: boolean;
    stop: string;
    periodStart: string;
    periodEnd: string;
    allDay: boolean;
    repeatDays: string[];
    repeatEveryday: boolean;
  }>({
    start: formattedNow,
    stopEnabled: false,
    stop: formattedNow,
    periodStart: "12:02",
    periodEnd: "11:28",
    allDay: false,
    repeatDays: [] as string[],
    repeatEveryday: false,
  });

  const toggleDay = (day: any) => {
    setSchedule((prev: any) => ({
      ...prev,
      repeatDays: prev.repeatDays.includes(day)
        ? prev.repeatDays.filter((d: any) => d !== day)
        : [...prev.repeatDays, day],
    }));
  };

  const fetchExperience = async (
    name: string,
    sortOrder: string,
    statusFilter: string,
    page: number,
    rowsPerPage: number
  ) => {
    setLoading(true);
    try {
      const response = await getExperienceList(
        name,
        sortOrder,
        statusFilter,
        page + 1,
        rowsPerPage
      );
      if (response.success === true) {
        setExperiences(response.experiences);
        setTotalExperiences(response.totalExperiences);
        setTotalPages(response.totalPage);
      }
    } catch (error) {
      console.error("Error fetching experience:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchExperience(name, sortOrder, statusFilter, page, rowsPerPage);
  }, [name, sortOrder, statusFilter, page, rowsPerPage]);


  
  const formik = useFormik({
    initialValues: {
      name: "",
      type: "Select Type",
      description: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        const response = await addExperienceList(
          values.name,
          values.type,
          values.description
        );
        if (response.success === true) {
          toast.success(response.message);
          formik.resetForm();
          setOpen(false);
          fetchExperience(search, sortOrder, statusFilter, page, rowsPerPage);
        }
      } catch (error: any) {
        console.error(
          "Error adding template:",
          error.response?.data || error.message
        );
      }
    },
  });
  const handleEdit = (experience: any) => {
    navigate(`/edit-experience/${experience.id}`, { state: { experience } });
  };

const handleCopy = async (experience: any) => {
  setCopyLoadingId(experience.id);
  try {
    const response = await copyExperience(experience.id)
    if(response.success === true){
      toast.success(response.message)
    }else{
      console.log('getting error')
    }
  } catch (error) {
    console.error("Error copying experience:", error);
  }finally {
    setCopyLoadingId(null); 
  }

};

  const handleStatusChange = (id: string, value: string) => {
    setSelected((prev) => ({ ...prev, [id]: value }));
  };
  const handleOpen = async (
    publicId: string,
    scheduleStatus: string,
    exp: any
  ) => {
    setSelectedExpId(publicId);
    setSelectedExpName(exp.name);
    setSelected((prev: any) => ({ ...prev, [publicId]: scheduleStatus }));
    setOpenSchedulePopup(true);
    try {
      const response = await getSchduleData(exp.id);
      if (response.success === true) {
        const scheduleData = response.schedule;
        setSelectedExp((prev: any) => ({
          ...prev,
          public_id: scheduleData.experience_id,
          schedule_status: scheduleData.status,
          ...scheduleData,
        }));
        const parsedRepeatDays = JSON.parse(scheduleData.repeat_days);
        setSelected((prev) => ({
          ...prev,
          [scheduleData.experience_id]: scheduleData.status,
        }));
        setSchedule({
          start: scheduleData.start_execution
            ? new Date(scheduleData.start_execution).toISOString().slice(0, 16)
            : "",
          stop: scheduleData.stop_execution
            ? new Date(scheduleData.stop_execution).toISOString().slice(0, 16)
            : "",

          stopEnabled: !!scheduleData.stop_execution,
          allDay: scheduleData.all_day,
          periodStart: scheduleData.period_start || "",
          periodEnd: scheduleData.period_end || "",
          repeatEveryday: !!scheduleData.repeat_everyday,
          repeatDays: scheduleData.repeat_everyday
            ? ["M", "T", "W", "Th", "F", "S", "Su"]
            : parsedRepeatDays.map((day: any) => {
                switch (day) {
                  case "Monday":
                    return "M";
                  case "Tuesday":
                    return "T";
                  case "Wednesday":
                    return "W";
                  case "Thursday":
                    return "Th";
                  case "Friday":
                    return "F";
                  case "Saturday":
                    return "S";
                  case "Sunday":
                    return "Su";
                  default:
                    return day;
                }
              }),
        });
      }
    } catch (error) {
      console.error("Error fetching schedule:", error);
    }
  };
  const formatTime = (timeStr: string): string => {
    if (!timeStr) return "";
    const parts = timeStr.split(":");
    if (parts.length === 2) {
      return `${timeStr}:00`;
    } else if (parts.length === 3) {
      return timeStr;
    }
    return "";
  };
  const handleReportClick = (experience: any) => {
    const exp_payload = {
      id: experience.id,
      name: experience.name,
    };
    navigate(`/report`, { state: exp_payload });
  };
  const handleSubmit = async (exp: any) => {
    const isScheduled = selected[exp.public_id] === "scheduled";
    if (!schedule.stopEnabled && isScheduled) {
      setStopError("Stop execution time is required.");
      return;
    }

    try {
      const payload: any = {
        experience_id: exp.experience_id,
        status: selected[exp.public_id] ?? exp.schedule_status,
      };

      if (payload.status === "scheduled") {
        payload.start_execution = schedule.start;
        payload.stop_execution = schedule.stop;
        payload.all_day = schedule.allDay;
        payload.repeat_everyday = schedule.repeatDays.length === 7;
        if (!schedule.allDay) {
          payload.period_start = formatTime(schedule.periodStart);
          payload.period_end = formatTime(schedule.periodEnd);
        }
        if (
          Array.isArray(schedule.repeatDays) &&
          schedule.repeatDays.length > 0
        ) {
          payload.repeat_days = schedule.repeatDays.map((day) => {
            const dayMapping: { [key: string]: string } = {
              M: "Monday",
              T: "Tuesday",
              W: "Wednesday",
              Th: "Thursday",
              F: "Friday",
              S: "Saturday",
              Su: "Sunday",
            };
            return dayMapping[day];
          });
        }
      }

      if (payload.status === "live") {
        payload.experience_id = exp.experience_id;
      }

      if (payload.status === "offline") {
        payload.experience_id = exp.experience_id;
      }

      const response = await ExperienceStatusChange(payload);
      if (response.success === true) {
        toast.success(response.message);
        fetchExperience(search, sortOrder, statusFilter, page, rowsPerPage); //
      } else {
        toast.error(response.error);
      }
      handleClose();
    } catch (error) {
      console.error("Error updating schedule:", error);
      alert("Failed to update schedule");
    }
  };

  const handleClose = () => setOpenSchedulePopup(false);
  const handleSearchChange = (e: any) => {
    setSearch(e.target.value);
  };
  const handleKeyPress = (e: any) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };
  const handleSearch = () => {
    if (search === "") {
      setName("");
    }
    setName(search);
    setPage(0);
  };
  const handleSortChange = (e: any) => {
    const value = e.target.value;
    setSortOrder(value);
    localStorage.setItem("sortOrder", value);
  };
  const handleStatusFilterChange = (e: any) => {
    const value = e.target.value;
    setStatusFilter(value);
    localStorage.setItem("statusFilter", value);
  };
  return (
    <div className="templates">
      <Grid container className="templates__header">
        <Grid
          size={{ xs: 12, md: 2, sm: 12 }}
          className="templates__header--search"
        >
          <h2>Experiences</h2>
        </Grid>

        <Grid
          size={{ xs: 12, md: 2, sm: 12 }}
          className="templates__header--search"
        >
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Search..."
            size="small"
            value={search}
            onChange={handleSearchChange}
            onKeyPress={handleKeyPress}
            InputProps={{
              startAdornment: (
                <IconButton>
                  <Search />
                </IconButton>
              ),
            }}
            style={{ flex: 1 }}
          />
        </Grid>

        <Grid
          size={{ xs: 12, md: 4, sm: 4 }}
          className="templates__header--filter br-1 text-center"
        >
          <span className="label--filter">Usecase : </span>
          <TextField
            select
            size="small"
            value={sortOrder}
            onChange={handleSortChange}
          >
            {/* <MenuItem value="all">Type</MenuItem> */}
            <MenuItem value="all">All</MenuItem>
            <MenuItem value="paywall">Paywall</MenuItem>
            <MenuItem value="lightbox">Lightbox </MenuItem>
          </TextField>
        </Grid>

        <Grid
          size={{ xs: 12, md: 2, sm: 4 }}
          className="templates__header--pagination br-1 text-center"
        >
          <TablePagination
            component="div"
            count={totalExperiences}
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={(_, newPage) => {
              if (newPage < totalPages) {
                setPage(newPage);
              }
            }}
            rowsPerPageOptions={[5, 10, 25]} // Page size options
            onRowsPerPageChange={(e) => {
              const newRowsPerPage = parseInt(e.target.value, 10);
              setRowsPerPage(newRowsPerPage);
              setPage(0); // Reset to first page when changing rows per page
            }}
            sx={{
              padding: "0px",
              overflow: "hidden",

              "& .MuiTablePagination-toolbar": {
                minHeight: "auto",
                padding: "0px",
              },
              "& .MuiTablePagination-selectLabel": {
                display: "none",
              },
              "& .MuiTablePagination-select": {
                display: "none",
              },
              "& .MuiTablePagination-spacer": {
                display: "none",
              },
            }}
          />
        </Grid>

        <Grid
          size={{ xs: 12, md: 2, sm: 4 }}
          className="templates__header--button"
        >
          <Button
            sx={{
              "--variant-containedBg": "rgba(228, 0, 43, 1)",
            }}
            variant="contained"
            color="error"
            onClick={() => setOpen(true)}
          >
            Compose
          </Button>
        </Grid>
      </Grid>

      {/* Add Experience Dialog */}
      <Dialog
        className="modal"
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <h2 className="mb-0">
          {" "}
          <span>
            <AddIcon />{" "}
          </span>{" "}
          Add Experience
        </h2>
        <IconButton
          aria-label="close"
          onClick={() => setOpen(false)}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <form onSubmit={formik.handleSubmit}>
          <DialogContent className="modal-content">
            <label>
              Name <span style={{ color: "red" }}>*</span>
            </label>
            {/* Title Field */}
            <TextField
              // label="Name"
              placeholder="Enter name"
              name="name"
              fullWidth
              required
              variant="standard"
              value={formik.values.name}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />

            {/* Type Dropdown */}
            <label>
              Type <span style={{ color: "red" }}>*</span>
            </label>
            <TextField
              select
              name="type"
              variant="standard"
              value={formik.values.type !== undefined ? formik.values.type : ""}
              fullWidth
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.type && Boolean(formik.errors.type)}
              helperText={formik.touched.type && formik.errors.type}
            >
              {type.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>

            {/* Description Field */}
            <label>Description</label>
            <TextField
              className="mb-0 "
              name="description"
              placeholder="Enter description"
              fullWidth
              multiline
              rows={3}
              value={formik.values.description}
              margin="normal"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.description && Boolean(formik.errors.description)
              }
              helperText={
                formik.touched.description && formik.errors.description
              }
            />
          </DialogContent>

          {/* Action Buttons */}
          <DialogActions>
            {/* <Button onClick={() => setOpen(false)} color="secondary">
            Cancel
          </Button> */}
            <Button
              className="button"
              type="submit"
              variant="contained"
              color="error"
              disabled={loading}
            >
              Add Experience
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      {/* Grid Layout */}

      <Grid container spacing={2} mb={2}>
        <Grid
          size={{ xs: 12, md: 12 }}
          sx={{
            alignItems: "flex-end",
            display: "flex",
            justifyContent: "flex-end",
            gap: "16px",
          }}
        >
          <div>
            <span className="label--filter">Schedule Status : </span>
            <TextField
              className="custom-filter"
              select
              size="small"
              value={statusFilter}
              onChange={handleStatusFilterChange}
            >
              <MenuItem value="all">All</MenuItem>
              <MenuItem value="live">Live</MenuItem>
              <MenuItem value="scheduled">Scheduled</MenuItem>
              <MenuItem value="offline">Offline</MenuItem>
            </TextField>
          </div>
          <div className="templates__header--viewMode">
            <Tooltip title="Grid View" placement="top" arrow>
              <IconButton
                onClick={() => setViewMode("grid")}
                className={viewMode === "grid" ? "active" : ""}
              >
                <GridViewIcon
                  color={viewMode === "grid" ? "error" : "inherit"}
                />
              </IconButton>
            </Tooltip>
            <Tooltip title="List View" placement="top" arrow>
              <IconButton
                className={viewMode === "list" ? "active" : ""}
                onClick={() => setViewMode("list")}
              >
                <ListViewIcon
                  color={viewMode === "list" ? "error" : "inherit"}
                />
              </IconButton>
            </Tooltip>
          </div>
        </Grid>
      </Grid>

      <Grid container spacing={2} className="experience">
        {viewMode === "grid" ? (
          experiences.map((exp: any, index) => (
            <Grid
              size={{
                xs: 12,
                sm: 6,
                md: 4,
              }}
              spacing={2}
              key={index}
              className={`experience__grid ${
                viewMode === "list" ? "experience__grid--list" : ""
              }`}
            >
              <div className={index === 0 ? "border border-red-500" : ""}>
                <Box sx={{ position: "absolute", top: 8, right: 15 }}>
                  <Tooltip title="Edit" arrow placement="top">
                    <IconButton
                      className="edit_icon"
                      size="small"
                      onClick={() => handleEdit(exp)}
                    >
                      <EditedIcon  />
                    </IconButton>
                  </Tooltip>
                  
                </Box>
                <Box sx={{ position: "absolute", top: 8, right: 48 }}>
                  <Tooltip title="Report" arrow placement="top">
                    <IconButton
                      className="edit_icon report_icon"
                      size="small"
                      onClick={() => handleReportClick(exp)}
                    >
                      <ReportIcon />
                    </IconButton>
                  </Tooltip>
                </Box>
                {userDetails.selected_environment === 'sandbox'  && <Box sx={{ position: "absolute", top: 8, right: 81 }}>
                <Tooltip title="Copy" arrow placement="top">
                    <IconButton
                      className="copy_icon"
                      size="small"
                      onClick={() => handleCopy(exp)}
                      disabled={copyLoadingId === exp.id}
                    >
                      <CopiedIcon fontSize="small"/>
                    </IconButton>
                  </Tooltip>
                  </Box>}
              
                <div>
                  <div className="experience__grid--heading">
                    <span className="Icon">
                      <BriefcaseIcon />
                    </span>{" "}
                    <h2>{exp.name}</h2>
                  </div>

                  <div className="experience__grid--review">
                    <div className="experience__grid--id">
                      <div className="Icon keyIcon">
                        <KeyIcon />
                      </div>{" "}
                      <h3> {exp.public_id}</h3>
                    </div>
                    <div className={`experience__grid--caption`}>
                      <span className="circleIcon Icon ">
                        <CircleIcon />
                      </span>{" "}
                      <h3
                        className={`status-label-grid status-${exp.schedule_status?.toLowerCase()}`}
                        onClick={() =>
                          handleOpen(exp.public_id, exp.schedule_status, exp)
                        }
                      >
                        {" "}
                        {exp.schedule_status}
                      </h3>
                      <span className="liveIcon Icon">
                        <LiveIcon />
                      </span>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </Grid>
          ))
        ) : (
          <Grid
            className="experience__list--table "
            size={{
              xs: 12,
            }}
          >
            {" "}
            <TableContainer sx={{ maxHeight: "65vh" }}>
              <Table stickyHeader sx={{ minWidth: 650 }}>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ textAlign: "left" }}> Name</TableCell>
                    <TableCell>
                      {" "}
                      <span className=" Icon ">
                        <CircleIcon style={{ height: "18px", width: "18px" }} />
                      </span>{" "}
                      Status
                    </TableCell>
                    <TableCell>
                      <span className="Icon">
                        <KeyIcon style={{ height: "18px", width: "18px" }} />
                      </span>{" "}
                      Key
                    </TableCell>
                    <TableCell>Report</TableCell>
                    <TableCell>Action</TableCell>
                    {userDetails.selected_environment === 'sandbox'  && <TableCell>Copy</TableCell>}

                  </TableRow>
                </TableHead>
                <TableBody>
                  {experiences.map((exp: any, index: number) => (
                    <TableRow key={index}>
                      <TableCell
                        style={{ textAlign: "left" }}
                        className="experience__list"
                      >
                        <div className="experience__list--heading">
                          <span className="Icon">
                            <BriefcaseIcon />
                          </span>{" "}
                          <h2 className="mb-0">{exp.name}</h2>
                        </div>
                      </TableCell>
                      <TableCell className="experience__grid--caption">
                        <h3
                          className={`status-label status-${exp.schedule_status?.toLowerCase()}`}
                          onClick={() =>
                            handleOpen(exp.public_id, exp.schedule_status, exp)
                          }
                        >
                          {" "}
                          {exp.schedule_status}
                        </h3>
                      </TableCell>
                      <TableCell className="experience__grid--id">
                        <h3> {exp.public_id}</h3>
                      </TableCell>
                      <TableCell className="experience__grid--id">
                        <IconButton
                          className="edit_icon report_icon"
                          size="small"
                          onClick={() => handleReportClick(exp)}
                        >
                          <ReportIcon />
                        </IconButton>
                      </TableCell>
                     
              

                      <TableCell className="">
                        <IconButton
                          className="edit_icon"
                          size="small"
                          onClick={() => handleEdit(exp)}
                        >
                          <EditedIcon />
                        </IconButton>
                      </TableCell>
                      {userDetails.selected_environment === 'sandbox'  && <TableCell className="experience__grid--id">
                <Tooltip title="Copy" arrow placement="top">
                    <IconButton
                      className="copy_icon"
                      size="small"
                      onClick={() => handleCopy(exp)}
                    >
                      <CopiedIcon fontSize="small"/>
                    </IconButton>
                  </Tooltip>
                  </TableCell>}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        )}

        <Dialog
          className="modal"
          open={openSchedulePopup}
          onClose={handleClose}
          fullWidth
          sx={{
            "& .MuiPaper-root": {
              maxWidth: "900px",
            },
          }}
        >
          <h2 className="mb-0">
            {" "}
            <span className="Icon">
              <CircleIcon />{" "}
            </span>{" "}
            {selectedExpName}
          </h2>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={(theme) => ({
              position: "absolute",
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            })}
          >
            <CloseIcon />
          </IconButton>

          <DialogContent className="modal-content">
            {/* Status Selection */}
            <Grid
          
              container
              spacing={{ xs: 1, sm: 1, md: 2 }}
              className="modal-content--section"
            >
              {[
                {
                  label: "Live",
                  sublabel: "Always run your experience",
                  value: "live",
                  color: "success",
                  icon: <StatusLiveIcon fontSize="large" />,
                },
                {
                  label: "Scheduled",
                  sublabel: "Schedule your experience",
                  value: "scheduled",
                  color: "warning",
                  icon: <ScheduledIcon fontSize="large" />,
                },
                {
                  label: "Offline",
                  sublabel: "Turn off your experience",
                  value: "offline",
                  color: "error",
                  icon: <OfflineIcon fontSize="large" />,
                },
              ].map((status) => (
                <Grid size={{ xs: 12, md: 4, sm: 4 }}>
                  <Box
                    key={status.value}
                    onClick={() =>
                      handleStatusChange(selectedExp.public_id, status.value)
                    }
                    sx={{
                      padding: "10px 30px",
                      border:
                        (selected[selectedExp.public_id] ??
                          selectedExp.schedule_status) === status.value
                          ? "1px solid rgba(228, 0, 43, 1)"
                          : "1px solid #ddd",
                      backgroundColor:
                        (selected[selectedExp.public_id] ??
                          selectedExp.schedule_status) === status.value
                          ? "#f8f8f8"
                          : "#fff",
                      cursor: "pointer",
                      transition: "0.3s",
                      boxShadow:
                        (selected[selectedExp.public_id] ??
                          selectedExp.schedule_status) === status.value
                          ? "0px 4px 10px rgba(0,0,0,0.1)"
                          : "none",
                    }}
                  >
                    <div className="card-status">
                      <div>{status.icon}</div>

                      <Typography
                        fontWeight="bold"
                        color={
                          (selected[selectedExp.public_id] ??
                            selectedExp.schedule_status) === status.value
                            ? status.color
                            : "inherit"
                        }
                      >
                        {status.label}
                      </Typography>
                    </div>
                    <div className="card-status-subheading">
                      <Typography variant="h4">{status.sublabel}</Typography>
                    </div>
                  </Box>
                </Grid>
              ))}
            </Grid>

            <Box className="card-setSchedule" mt={2}>
              <Typography variant="h4" mb={2}>
                Set a Schedule
              </Typography>

              <Grid container spacing={2} p={2}>
                <Grid size={{ xs: 12, md: 4 }}>
                  <label className="card-setSchedule--label">
                    Start Executing On
                  </label>
                  <div className="custom_datepicker">
                    <TextField
                      variant="outlined"
                      type="datetime-local"
                      value={schedule.start}
                      onChange={(e) =>
                        setSchedule({ ...schedule, start: e.target.value })
                      }
                      inputProps={{
                        min: minDateTime,
                      }}
                      fullWidth
                      disabled={selected[selectedExp.public_id] !== "scheduled"}
                    />
                  </div>
                </Grid>

                <Grid size={{ xs: 12, md: 4 }} spacing={2}>
                  <FormControlLabel
                    className="check_box"
                    value="end"
                    control={
                      <Checkbox
                        checked={schedule.stopEnabled}
                        onChange={(e) =>
                          setSchedule({
                            ...schedule,
                            stopEnabled: e.target.checked,
                          })
                        }
                        disabled={
                          selected[selectedExp.public_id] !== "scheduled"
                        }
                      />
                    }
                    label=" Stop Executing On "
                    labelPlacement="end"
                  />

                  <div className="custom_datepicker">
                    <TextField
                      variant="outlined"
                      type="datetime-local"
                      value={schedule.stop}
                      inputProps={{
                        min: minDateTime,
                      }}
                      disabled={
                        !schedule.stopEnabled ||
                        selected[selectedExp.public_id] !== "scheduled"
                      }
                      error={!!stopError}
                      helperText={stopError}
                      onChange={(e) => {
                        const stopValue = e.target.value;
                        let error = "";
                        const isScheduled =
                          selected[selectedExp.public_id] === "scheduled";
                        if (isScheduled) {
                          if (!schedule.stopEnabled) {
                            error = "Stop execution time is required.";
                          } else if (
                            schedule.start &&
                            new Date(stopValue) <= new Date(schedule.start) &&
                            isScheduled
                          ) {
                            error =
                              "Stop execution must be later than start execution.";
                          }
                        }

                        setStopError(error);
                        setSchedule({ ...schedule, stop: stopValue });
                      }}
                      fullWidth
                      InputProps={{
                        sx: {
                          padding: "10px 15px",
                          background: "rgba(247, 247, 247, 1)",

                          border: "1px solid rgba(212, 212, 212, 1)",
                          "& .MuiSvgIcon-root": { display: "none" },
                        },
                      }}
                    />
                  </div>
                </Grid>
                <Grid size={{ xs: 12, md: 2 }} spacing={2}>
                  <label className="card-setSchedule--label">
                    Period of the day
                  </label>
                  <div className="custom_datepicker">
                    <TextField
                      variant="outlined"
                      type="time"
                      value={schedule.periodStart}
                      onChange={(e) =>
                        setSchedule({
                          ...schedule,
                          periodStart: e.target.value,
                        })
                      }
                      disabled={
                        selected[selectedExp.public_id] !== "scheduled" ||
                        schedule.allDay
                      }
                    />
                  </div>
                </Grid>
                <Grid size={{ xs: 12, md: 2 }} spacing={2}>
                  <FormControlLabel
                    className="check_box"
                    value="end"
                    control={
                      <Checkbox
                        checked={schedule.allDay}
                        onChange={(e) =>
                          setSchedule({
                            ...schedule,
                            allDay: e.target.checked,
                          })
                        }
                        disabled={
                          selected[selectedExp.public_id] !== "scheduled"
                        }
                      />
                    }
                    label="All Day"
                    labelPlacement="end"
                  />

                  <div className="custom_datepicker">
                    <TextField
                      variant="outlined"
                      type="time"
                      value={schedule.periodEnd}
                      onChange={(e) =>
                        setSchedule({
                          ...schedule,
                          periodEnd: e.target.value,
                        })
                      }
                      disabled={
                        selected[selectedExp.public_id] !== "scheduled" ||
                        schedule.allDay
                      }
                    />
                  </div>
                </Grid>
              </Grid>

              <Box
                p={2}
                display="flex"
                gap={2}
                alignItems="center"
                flexWrap="wrap"
              >
                <Typography variant="body2">Repeat on Days:</Typography>
                <Box display="flex" gap={1} flexWrap="wrap">
                  {["M", "T", "W", "Th", "F", "S", "Su"].map((day) => (
                    <Box
                      className="date_lists"
                      key={day}
                      onClick={() => toggleDay(day)}
                      sx={{
                        border: schedule.repeatDays.includes(day)
                          ? "1px solid red"
                          : "1px solid #ddd",
                        cursor:
                          selected[selectedExp.public_id] === "scheduled"
                            ? "pointer"
                            : "not-allowed",
                        backgroundColor: schedule.repeatDays.includes(day)
                          ? "#f8f8f8"
                          : "#fff",
                        opacity:
                          selected[selectedExp.public_id] === "scheduled"
                            ? 1
                            : 0.5,
                        pointerEvents:
                          selected[selectedExp.public_id] === "scheduled"
                            ? "auto"
                            : "none",
                      }}
                    >
                      {day}
                    </Box>
                  ))}

                  <FormControlLabel
                    className="check_box everyday"
                    value="end"
                    control={
                      <Checkbox
                        checked={schedule.repeatDays.length === 7}
                        onChange={(e) =>
                          setSchedule((prev: any) => ({
                            ...prev,
                            repeatDays: e.target.checked
                              ? ["M", "T", "W", "Th", "F", "S", "Su"]
                              : [],
                          }))
                        }
                        disabled={
                          selected[selectedExp.public_id] !== "scheduled"
                        }
                      />
                    }
                    label="Every Day"
                    labelPlacement="end"
                  />
                </Box>
              </Box>
            </Box>
          </DialogContent>

          {/* Dialog Actions */}
          <DialogActions disableSpacing className="modal_footer--button">
            <Button
              variant="contained"
             
              className="button"
              onClick={() => handleSubmit(selectedExp)}
              sx={{
                "--variant-containedBg": "rgba(228, 0, 43, 1)",
                 "&:hover": {
                 
                  "--variant-containedBg": "rgba(228, 0, 43, 1)",
                  "--variant-textBg": "rgba(228, 0, 43, 0.04)",
                },
              }}
              disabled={loading}
            >
              {loading ? (
                <span className="loader"/>
              ) : (
                "Save Changes"
              )}
            </Button>
            <Button
              sx={{
                "--variant-outlinedBorder": "rgba(228, 0, 43, 1)",
                "--variant-outlinedColor": "rgba(228, 0, 43, 1)",
                "--variant-containedBg": "rgba(228, 0, 43, 1)",

                "&:hover": {
                  "--variant-outlinedBorder": "rgba(228, 0, 43, 1)",
                  "--variant-outlinedBg": "rgba(228, 0, 43, 0.04)",
                  "--variant-containedBg": "rgba(228, 0, 43, 1)",
                  "--variant-textBg": "rgba(228, 0, 43, 0.04)",
                },
              }}
              variant="outlined"
              color="primary"
              className="button"
              onClick={handleClose}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
        <ToastContainer position="top-right" autoClose={3000} />
      </Grid>
    </div>
  );
};

export default Experience;
